import { Heading } from 'grommet';
import React from 'react';
const PageTitle = (props) => {
    const { text, level = 2, textAlign = 'center', } = props;
    return (React.createElement(Heading, { fill: true, level: level, textAlign: textAlign, ...props }, text));
};
PageTitle.displayName = 'PageTitle';
export default PageTitle;
